export default __webpack_public_path__ + "static/media/home-bg.12bb713a.jpg";